import {Graphics} from 'pixi.js';
import GameConfig from 'src/game/GameConfig';
import GameModel from 'src/game/GameModel';
import {Game} from 'src/game/Game';

export class BuildabilityRenderer {
    public needsRerender: boolean = true;

    private container: Graphics = new Graphics();
    private game: Game;

    public tick(): void {
        if (!this.game) return;
        if (!this.game.mode.showBuildability) return;
        if (this.needsRerender) {
            this.needsRerender = false;
            this.render();
        }
    }

    private render(): void {
        this.container.clear();
        this.container.alpha = 0.3;
        const minDistanceGrid = this.game.buildability.minDistanceGrids[this.game.index];
        this.game.map.forEachTile(({x, y}) => {
            const canBuild = minDistanceGrid[y][x] < 20;
            if (canBuild) return;
            this.container
                .beginFill(0x8f0000)
                .drawRect(
                    x * GameConfig.tileSize,
                    y * GameConfig.tileSize,
                    GameConfig.tileSize,
                    GameConfig.tileSize
                )
                .endFill();
        });
    }

    public show(game: Game): void {
        this.game = game;
        if (!this.game.mode.showBuildability) return;
        this.render();
        GameModel.cursorContainer.addChild(this.container);
    }

    public hide(): void {
        if (!this.game.mode.showBuildability) return;
        GameModel.cursorContainer.removeChild(this.container);
    }
}

export const buildabilityRenderer = new BuildabilityRenderer();



// WEBPACK FOOTER //
// ./src/Pixi/map/BuildabilityRenderer.ts